import { Box, Typography, useTheme } from '@mui/material';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import { LocationDetails } from '~/types';
import { FLIGHT_TYPE } from '~/literals';
import useMediaQuery from '@mui/material/useMediaQuery';
interface TripDestinationAndArrivalProps {
  flightType: string;
  departure: LocationDetails;
  arrival: LocationDetails;
}

const TripDestinationAndArrival = ({ flightType, departure, arrival }: TripDestinationAndArrivalProps) => {
  const theme = useTheme();
  const isTab = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      display="flex"
      alignItems="center"
      width="100%"
      justifyContent="space-between"
      flexDirection={isTab ? "column" : "row"}
    >
      <Box
        display="flex"
        alignItems="center"
        gap={2}
      >
        <Typography variant="h5">
          {departure.city.friendlyName} ({departure.location.code})
        </Typography>

        {flightType === FLIGHT_TYPE.ONE_WAY ? (
          <ArrowRightAltIcon
            sx={{
              fontSize: '1rem',
              borderRadius: '50%',
              backgroundColor: 'grey.300',
              p: 1,
            }}
          />
        ) : (
          <CompareArrowsIcon
            sx={{
              fontSize: '1rem',
              borderRadius: '50%',
              backgroundColor: 'grey.300',
              p: 1,
            }}
          />
        )}

        <Typography variant="h5">
          {arrival.city.friendlyName} ({arrival.location.code})
        </Typography>
      </Box>
      <Typography variant="subtitle1" style={{
        width: isTab ? '100%' : '',
        textAlign: 'center',
        paddingTop: isTab ? '10px' : '',
        marginTop: isTab ? '10px' : ''
      }}>
        Reservation Type: <strong>{flightType === FLIGHT_TYPE.ONE_WAY ? "One way" : "Return"}</strong>
      </Typography>
    </Box>
  );
};

export default TripDestinationAndArrival;
